<div class="main-container">
  <!-- Loading State - Blank white page with loader -->
  <div class="loading-state" *ngIf="currentView === 'loading'">
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
  </div>

  <!-- Left Panel -->
  <div class="left-panel" *ngIf="currentView !== 'loading'">
    <div class="left-panel-content">
      <div class="logo-section">
        <div class="askme-logo">
          <div class="chatbot-icon-small"></div>
        </div>
      </div>
      <div class="icons-section">
        <div class="icon-item" [class.active]="isChatHistoryOpen" (click)="toggleChatHistory()">
          <div class="chats-icon"></div>
          <div class="tooltip">Chart History</div>
        </div>
        <div class="icon-item" [class.active]="isSavedQuestionsOpen" (click)="toggleSavedSelections()">
          <div class="stars-icon"></div>
          <div class="tooltip">Saved Questions</div>
        </div>
        <div class="icon-item" [class.active]="isQuestionBrowserOpen" (click)="toggleQuestionBrowser()">
          <div class="questions-icon"></div>
          <div class="tooltip">Question Browser</div>
        </div>
      </div>
      <div class="home-section">
        <div class="icon-item" [class.animating]="isDiagnosticAnimating" title="Diagnostic" (click)="viewOnline()">
          <div class="diagnostic-icon"></div>
        </div>
        <div class="icon-item" title="Home" (click)="goToWelcomeSection()">
          <div class="home-icon"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Landing View -->
  <div class="landing-container" *ngIf="currentView === 'landing'">
    <div class="main-content">
      <div class="content-wrapper">
        <div class="welcome-section">
          <div class="welcome-header">
            <div class="logo-container">
              <div class="chatbot-icon"></div>
            </div>
            <h1 class="welcome-text">How can I help you?</h1>
          </div>
          <!-- Search Box -->
          <div class="search-box">
            <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="search-form">
              <div class="search-input-wrapper">
                <input type="text" formControlName="query" placeholder="Ask me anything..." class="search-input" />
              </div>
              <button type="submit" class="send-button">
                <div class="send-arrow"></div>
              </button>
            </form>
          </div>
        </div>
        <div class="suggestions-wrapper">
          <!-- Key Questions -->
          <div class="key-questions-container">
            <div class="header">
              <div class="header-content">
                <div class="title-section active">
                  <h2 class="title">
                    <span class="title-light">Key</span> <span class="title-bold">Questions</span>
                  </h2>
                </div>
                <div class="tabs">
                  <div class="tab-icon" [class.active]="!isListView" (click)="toggleView()">
                    <div class="grid-icon"></div>
                  </div>
                  <div class="tab-icon" [class.active]="isListView" (click)="toggleView()">
                    <div class="list-icon"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="questions-list" [class.grid-view]="!isListView" [class.list-view]="isListView">
              <!-- List View -->
              <ng-container *ngIf="isListView">
                <div class="question-item" *ngFor="let question of questions; trackBy: trackByIndex"
                  (click)="sendKeyQuestion(question)">
                  <div class="arrow-icon">
                    <div class="chevron-left"></div>
                  </div>
                  <p class="key-question-text">{{ question }}</p>
                </div>
              </ng-container>

              <!-- Grid View -->
              <div class="questions-grid" *ngIf="!isListView">
                <div class="question-card" *ngFor="let question of questions; trackBy: trackByIndex; let i = index"
                  (click)="navigateToChat()">
                  <div class="card-image" [style.background-image]="getGridImage(i)"></div>
                  <p class="card-text">{{ truncateText(question, 150) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="powered-by">
            <span class="powered-text">Powered by</span>
            <div class="kai-logo"></div>
          </div>
          <div class="explorer-logo"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat View -->
  <div class="chat-container" [class.chat-collapsed]="!isChatAreaVisible" *ngIf="currentView === 'chat'">
    <!-- Chat Panel -->
    <div class="chat-area" [class.hidden]="!isChatAreaVisible">
      <div class="sidebar-toggle-left-panel" *ngIf="!isChatAreaVisible" (click)="toggleChatArea()">
        <div class="sidebar-icon"></div>
        <div class="tooltip">Open Chat</div>
      </div>
      <div class="chat-content">
        <div class="brand-logo-section">
          <div class="client-logo">
            <img *ngIf="logo_url" [src]="logo_url" alt="Brand Logo" class="brand-logo-img" />
            <div *ngIf="!logo_url" class="placeholder-logo">
            </div>
          </div>
          <div class="sidebar-toggle" (click)="toggleChatArea()">
            <div class="sidebar-icon"></div>
            <div class="tooltip">Hide Chat</div>
          </div>
        </div>
        <div class="get-started-section">
          <div class="chatbot-icon-large">
            <div class="chatbot-vector"></div>
          </div>
          <p class="get-started-text" *ngIf="!chatPreviewBlocks || chatPreviewBlocks.length === 0">Ask a question to get started test</p>
        </div>
        <div class="chat-history-scroll" #chatHistoryScroll>
          <div class="chat-history-content">
            <ng-container *ngFor="let chat of chatPreviewBlocks">
              <div class="chat-bubble">
                <div class="question-box-ui">
                  <span class="question-text-ui" [style.cursor]="chat.messageId ? 'pointer' : 'default'"
                    (click)="chat.messageId ? getChatResponse(chat.messageId) : null">
                    {{ chat.question }}
                  </span>
                </div>
                <!-- Markdown Response Section -->
                <div class="markdown-response-box">
                  <p class="markdown-text">Brand X brand equity shows strong performance with a Demand Power of 12.4%, Salience at 143.9, Meaningful at 130.4, and Difference at 141.1. Compared to competitors, Brand X leads in Salience and Difference, while Brand Y has higher Demand Power at 16.3%. Brand X Meaningful score is competitive, but slightly lower than Brand Y 158.1.</p>
                </div>
                <div class="action-icons">
                  <div class="icon-button like-icon" [class.liked]="chat.isLiked === true" (click)="onLikeClick(chat)"
                    [title]="chat.isLiked === true ? 'Remove like' : 'Like this response'"></div>
                  <div class="icon-button dislike-icon" [class.disliked]="chat.isLiked === false"
                    (click)="onDislikeClick(chat)"
                    [title]="chat.isLiked === false ? 'Remove dislike' : 'Dislike this response'"></div>
                  <div class="icon-button star-icon" [class.starred]="chat.isStarred" (click)="toggleStarred(chat)"
                    [title]="chat.isStarred ? 'Remove from saved' : 'Save question'"></div>
                  <div class="icon-button trash-icon" (click)="onDeleteClick(chat)" title="Delete this message"></div>
                  <p class="ai-disclaimer">Response is generated by AI.<br>Please check important information.</p>
                </div>

                <!-- Dislike Feedback Input Box -->
                <div class="dislike-feedback-box" *ngIf="chat.showDislikeInput">
                  <div class="dislike-feedback-content">
                    <p class="dislike-feedback-label">What went wrong? (Optional)</p>
                    <div class="dislike-feedback-input-wrapper">
                      <input type="text" class="dislike-feedback-input" placeholder="Tell us what could be improved..."
                        [(ngModel)]="chat.dislikeReason" (keyup.enter)="submitDislikeFeedback(chat)" />
                      <div class="dislike-feedback-actions">
                        <div class="dislike-submit-btn" (click)="submitDislikeFeedback(chat)" title="Submit feedback">
                          <div class="submit-icon"></div>
                        </div>
                        <div class="dislike-cancel-btn" (click)="cancelDislikeFeedback(chat)" title="Cancel">
                          <div class="cancel-icon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="footer-section">
          <div class="new-chat-button" (click)="navigateToLanding()">
            <div class="new-chat-icon"></div>
          </div>
          <div class="search-box-container">
            <div class="search-input-wrapper">
              <input type="text" class="search-input" placeholder="Ask Me Anything..." [(ngModel)]="searchText"
                (keyup.enter)="onSendMessage()">
              <div class="send-button" (click)="onSendMessage()">
                <div class="send-arrow-icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Output Area -->
    <div class="output-area">
      <div class="output-box">
        <!-- Question Display (restored) -->
        <div class="question-display" *ngIf="chatPreviewBlocks.length > 0">
          <div class="question-header">
            <h2 class="question-title">{{ chatPreviewBlocks[chatPreviewBlocks.length - 1].question }}</h2>
            <div class="question-actions" style="display: flex; align-items: center; gap: 8px;">
              <!-- Download Button (exports-popup-container) placed to the left of Selection Summary Button -->
              <div class="exports-popup-container" *ngIf="!failedCase && isCreateBtnClick">
                <div class="exports-popup-container-img-block"
                  [ngClass]="{ 'exports-popup-container-img-block-Active' : isExportspopup}" (click)="Exportspopup()">
                </div>
                <div class="setting-container showPanel"
                  [ngStyle]="{right:isInsightsBtnEnabled && is_AI_Integration?'8.5%':'1%'}" *ngIf="isExportspopup">
                  <div class="setting-blocks editablePPTSettings" *ngIf="mcode!=1" [ngClass]="{ 'disabled':
                          !(pptExport &&
                          (isVerticalGroupBarChartClick ||
                            isVerticalBarChartClick ||
                            isVerticalStackChartClick ||
                            isLineChartClick))
                        }" (click)="handlePPTExportClick()">
                    <div class="setting-block-icon ppt-icon"></div>
                    <div class="setting-block-name">PPT</div>
                  </div>
                  <div class="setting-blocks editablePPTSettings" *ngIf="mcode==1" (click)="handlePPTExportClick()">
                    <div class="setting-block-icon ppt-icon"></div>
                    <div class="setting-block-name">PPT</div>
                  </div>
                  <div class="setting-blocks excelexportSettings" [ngClass]="{'disabled':!isCreateBtnClick}"
                    (click)="handleExportClick()">
                    <div class="setting-block-icon excel-icon"></div>
                    <div class="setting-block-name">Excel</div>
                  </div>
                </div>
              </div>
              <!-- Selection Summary Button -->
              <button class="selection-summary-btn" *ngIf="isCreateBtnClick"
                (click)="SelectionsummaryCollapseExpand('SelectionSummary')">
                Selection Summary
              </button>
            </div>
          </div>
          <div class="question-divider"></div>
        </div>

        <!-- Chart/Output Area -->
        <div [ngClass]="showSnapshot && !failedCase ? 'chart-snapshot' : 'chart'">
          <!-- Output Configuration Controls -->
          <div class="outputData-config" [ngClass]="{ outputGap: is_indexing }" *ngIf="!showSnapshot && !failedCase">
            <div class="sigIndexContainer" *ngIf="is_indexing">
              <div class="sig-data-block" [ngClass]="{ not_active: isSig == false }" (click)="toggleSigBlock('Sig')">
                <div>Sig</div>
              </div>
              <div class="index-data-block" [ngClass]="{ itemDisable: isTranspose, active: isIndex }"
                (click)="toggleSigBlock('Index')" (mouseover)="$event.stopPropagation()">
                <div>Index</div>
              </div>
            </div>
            <div class="significanceContainer" *ngIf="!isIndex">
              <div class="significanceMainContainer" *ngIf="is_sigtesting && is_Time_Period_Present">
                <div class="significanceLabel">Significance</div>
                <div class="significanceDropDown significance">
                  <div class="significance-block" (click)="togglePanel('significance')">
                    <ng-container *ngIf="SignificanceVsReference">
                      <div class="sigNameContainer" title="{{ DefaultSampleSize }} : {{
                          replacePipe(SignificanceVsReference)
                        }}">
                        <div class="weighted-text-block">
                          {{ DefaultSampleSize }} :
                          {{ replacePipe(SignificanceVsReference) }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!SignificanceVsReference">
                      <div class="sigNameContainer" title="{{ DefaultSampleSize }}">
                        <div class="weighted-text-block">
                          {{ DefaultSampleSize }}
                        </div>
                      </div>
                    </ng-container>
                    <div class="arrow-weighted-block">
                      <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: sampleSizeDropdown }">
                      </div>
                    </div>
                  </div>
                  <div class="sampleSize-sub-items" *ngIf="sampleSizeDropdown">
                    <div *ngFor="let list of SampleSizeList" class="sub-items-block"
                      (click)="SampleSizeDropDownClick(list.key)" [ngClass]="{
                        disabled:
                          (list.key === 'Pairwise' && isDisablePairWise) ||
                          (list.key === 'Reference' && isDisableReference)
                      }">
                      <div class="sample_size_block">
                        <div class="sub-items-names">{{ list.key }}</div>
                      </div>
                      <div class="side-panel-arrow-sig" *ngIf="list.key === 'Reference'">
                        <div class="arrowToggle metric-list-open"></div>
                      </div>
                    </div>
                  </div>
                  <div class="Reference-sub-items-significance" *ngIf="isReference">
                    <div class="reference-panel-search">
                      <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                        autocomplete="off" name="searchTextLevel1" />
                      <div class="search-icon">
                        <div class="search-icon-image"></div>
                      </div>
                    </div>
                    <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
                        hide: !list.Child.toLowerCase().includes(
                          searchTextLevel1.toLowerCase()
                        )
                      }" (click)="referenceDropDownClickIndexSignificance(list.Child)">
                      <div class="reference-icon-container">
                        <div class="radio-icon" [ngClass]="{
                            'radio-icon-active': isSelectedSignificance(list.Child)
                          }"></div>
                      </div>
                      <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                        <div class="sub-items-names">
                          {{ replacePipe(list.Child) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="confidenceLevelContainer" *ngIf="is_confidenceLevel.length > 0 && !isIndex">
              <div class="confidenceLevelMainContainer" *ngIf="is_Time_Period_Present">
                <div class="confidanceLabel">Confidence Level</div>
                <div class="confidanceDropDown confidance">
                  <div class="confidence-block" [ngClass]="{ itemDisable: DefaultSampleSize == 'None' }"
                    (click)="togglePanel('confidence')">
                    <div class="confidence-text-block">
                      {{ DefaultConfidenceLevel }}
                    </div>
                    <div class="arrow-weighted-block arrowBlock">
                      <div class="arrowToggle arrowToggleIcon"
                        [ngClass]="{ arrowCollapsedIcon: confidenceLevelDropDown }"></div>
                    </div>
                  </div>
                  <div class="confidence-sub-items" *ngIf="confidenceLevelDropDown">
                    <div *ngFor="let list of is_confidenceLevel" class="sub-items-block"
                      (click)="confidenceDropDownClick(list.key)">
                      <div class="sub-items-names">{{ list.key }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ReferenceLevelContainer" *ngIf="isIndex">
              <div class="ReferenceLevelMainContainer">
                <div class="ReferenceLabel">Reference</div>
                <div class="ReferenceDropDown reference">
                  <div class="Reference-block" (click)="togglePanel('reference')">
                    <div class="Reference-text-block-main">
                      <div class="Reference-text-block" title="{{ DefaultReferenceLevel }}">
                        {{ DefaultReferenceLevel }}
                      </div>
                    </div>
                    <div class="arrow-weighted-block referenceArrowBlock">
                      <div class="arrowToggle arrowToggleIcon"
                        [ngClass]="{ arrowCollapsedIcon: referenceLevelDropDown }">
                      </div>
                    </div>
                  </div>
                  <div class="Reference-sub-items" *ngIf="referenceLevelDropDown">
                    <div class="reference-panel-search">
                      <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                        autocomplete="off" name="searchTextLevel1" />
                      <div class="search-icon">
                        <div class="search-icon-image"></div>
                      </div>
                    </div>
                    <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
                  hide: !list.Child.toLowerCase().includes(
                    searchTextLevel1.toLowerCase()
                  )
                }" (click)="referenceDropDownClick(list.Child)">
                      <div class="reference-icon-container">
                        <div class="radio-icon" [ngClass]="{
                      'radio-icon-active': isSelected(list.Child)
                    }"></div>
                      </div>
                      <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                        <div class="sub-items-names">
                          {{ replacePipe(list.Child) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="DataContainer" *ngIf="SampleSizeContainer && !showSnapshot">
              <div class="dataMainContainer">
                <div class="dataDropDownContainer dataDropdown">
                  <div class="data-block-main" (click)="togglePanel('datadropdown')">
                    <div class="sigNameContainer" title="{{ DefaultDataDropDown }}">
                      <div class="weighted-text-block">
                        {{ DefaultDataDropDown }}
                      </div>
                    </div>

                    <div class="arrow-weighted-block">
                      <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: dataDropDown }"></div>
                    </div>
                  </div>
                  <div class="data-sub-items" *ngIf="dataDropDown">
                    <div *ngFor="let list of dataDropDownList" class="sub-items-block" (click)="toggleDataBlock(list)">
                      <div class="sample_size_block">
                        <div class="sub-items-names">{{ list }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="ChartMainContainer">
              <ng-container *ngIf="is_chart_visualization">
                <div class="iconsContainerMain" (mouseover)="showMainTooltip = true"
                  (mouseleave)="showMainTooltip = false">
                  <div class="iconsContainer" [ngClass]="{ itemDisable: !isChartView }">
                    <div class="tablePreview" [ngClass]="{ bg: displayTable }" (click)="onTableIconClick()">
                      <div class="iconContainer">
                        <div class="output-icon" [ngClass]="displayTable ? 'table-icon-white' : 'table-icon'"></div>
                      </div>
                    </div>

                    <div class="tooltipMain" (mouseover)="onChartIconMouseOver('stack', $event)"
                      (mouseleave)="onChartIconMouseLeave('stack')">


                      <div class="columnChartPreview" #preview
                        [ngClass]="{ bg: isVerticalStackChartClick && !disableStackChart,itemDisable: !disableStackChart && !isVerticalStackChartClick}">
                        <div class="iconContainer">
                          <div class="output-icon"
                            [ngClass]="isVerticalStackChartClick ? 'horizontal-bar-icon-white': 'horizontal-bar-icon'">
                          </div>
                        </div>
                      </div>
                      <div class="chart-tooltip"
                        *ngIf="showStackTooltip && !isIndex && (!disableStackChart && !isVerticalStackChartClick)">
                        <ul>
                          <ng-container *ngFor="let item of StackChartToolTip">
                            <li [innerHTML]="item"></li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>

                    <div class="tooltipMain" (mouseover)="onChartIconMouseOver('line', $event)"
                      (mouseleave)="onChartIconMouseLeave('line')">
                      <div class="lineChartPreview" [ngClass]="{
                      bg: isLineChartClick && !disableLineChart,
                      itemDisable: !disableLineChart && !isLineChartClick
                    }" (click)="onTrendChartIconClick()">
                        <div class="iconContainer">
                          <div class="output-icon" [ngClass]="
                          isLineChartClick
                            ? 'trend-chart-icon-white'
                            : 'trend-chart-icon'
                        "></div>
                        </div>
                      </div>
                      <div class="chart-tooltip"
                        *ngIf="showLineTooltip && !isIndex && (!disableLineChart && !isLineChartClick)">
                        <ul>
                          <ng-container *ngFor="let item of LineChartToolTip">
                            <li [innerHTML]="item"></li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                    <div class="tooltipMain" (mouseover)="onChartIconMouseOver('bar', $event)"
                      (mouseleave)="onChartIconMouseLeave('bar')">
                      <div class="GrpVertical" [ngClass]="{
                      bg: isVerticalGroupBarChartClick || isVerticalBarChartClick
                    }" (click)="VerticalChartClick('column')">
                        <div class="iconContainer">
                          <div class="output-icon grp-bar-icon" [ngClass]="
                          isVerticalGroupBarChartClick || isVerticalBarChartClick
                            ? 'grp-bar-icon-white'
                            : 'grp-bar-icon'
                        "></div>
                        </div>
                      </div>
                      <div class="chart-tooltip" *ngIf="showBarTooltip && !isIndex && (!isChartView)">
                        <ul>
                          <ng-container *ngFor="let item of BarChartToolTip">
                            <li [innerHTML]="item"></li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="chart-tooltip" *ngIf="showMainTooltip && (isIndex || !isChartView)">
                    <ul>
                      <ng-container *ngFor="let item of GeneralToolTip">

                        <li [innerHTML]="item"></li>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </div>


            <div class="TotalTransposeContainer">
              <div class="Totaltranpose-block transpose-block" [ngClass]="{
                  itemDisable: isLineChartClick || isTotal || isPairWise || isIndex
                }" (click)="OnTransposeClick()" *ngIf="is_TransposeBtn">
                <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': isTranspose }"></div>
                <div class="btn-text">Transpose</div>
              </div>
            </div>
          </div>

          <!-- Table and Chart Output Wrapper -->
          <div [ngClass]="showSnapshot ? 'table-output-wrapper-snapshot' : 'table-output-wrapper'">
            <div class="table-output" *ngIf="!showSnapshot && !failedCase">
              <app-table-ouput *ngIf="displayTable" [data]="OutputdataObject" [isTranspose]="isTranspose"
                [isTotalBase]="isTotalBase" [isAnswerBase]="isAnswerBase" [isSampleSize]="isSampleSize"
                [selectedDataFormat]="selectedDataFormat" [isWeightedLabel]="isWeightedLabel"
                [DefaultConfidenceLevel]="DefaultConfidenceLevel" [isWeightedNumerator]="isWeightedNumerator"
                [isUnWeightedNumerator]="isUnWeightedNumerator" [insufficientBase]="insufficientBase"
                [LowBase]="LowBase" [DefaultSampleSize]="DefaultSampleSize" [isSampleSizeBlock]="isSampleSizeBlock"
                [isWeightedSampleBlock]="isWeightedSampleBlock" [isPairWise]="isPairWise" [threshold]="threshold"
                [selectedIndex]="selectedIndex" [isIndex]="isIndex" [selectedWeight]="selectedWeight"></app-table-ouput>

              <!-- Chart Components -->
              <app-vertical-group-bar-chart *ngIf="isVerticalGroupBarChartClick" [insufficientBase]="insufficientBase"
                [LowBase]="LowBase"></app-vertical-group-bar-chart>
              <app-vertical-bar-chart *ngIf="isVerticalBarChartClick" [insufficientBase]="insufficientBase"
                [LowBase]="LowBase"></app-vertical-bar-chart>
              <app-stackChart *ngIf="isVerticalStackChartClick" [insufficientBase]="insufficientBase"
                [LowBase]="LowBase"></app-stackChart>
              <app-lineChart *ngIf="isLineChartClick" [insufficientBase]="insufficientBase"
                [LowBase]="LowBase"></app-lineChart>
            </div>

            <!-- Snapshot Output -->
            <div *ngIf="!arktabaccess">
              <app-output-popup *ngIf="showSnapshot && !failedCase" [id]="filteredWidgetID" [snapProduct]="'custom'"
                [popUpParameter]="filteredWidgetData.widget_name" [customData]="filteredWidgetData"
                [showSnapshotARK]="showSnapshot"></app-output-popup>
            </div>

            <!-- Insights Display -->
            <div *ngIf="isInsightspopupOpen" class="output-insights">
              <div class="insights-div">
                <div class="insights-icon">
                  <img src="../../../assets/images/explorerPlus/Insights_Icon.svg" alt="Insights">
                </div>
                <div class="insights-text" #insightsContainer>
                  <div class="insights-header">
                    <h3>Insights:</h3>
                  </div>
                  <div class="streaming-dots" *ngIf="!failedCase && insightsVal.length === 0">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <p *ngIf="failedCase">{{ insightsVal }}</p>
                  <ul *ngIf="!failedCase && insightsVal.length > 0">
                    <li *ngFor="let detail of insightsVal; let i = index" class="insight-item"
                      [style.animation-delay.ms]="i * 300" [innerHTML]="formatMarkdown(detail)"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer - Always outside the white output area, inside chat-container -->
      <div class="footer">
        <div class="powered-by">
          <span class="powered-text">Powered by</span>
          <div class="kai-logo"></div>
        </div>
        <div class="explorer-logo"></div>
      </div>

      <!-- Selection Summary Component -->
      <div class="selection-summary-component" *ngIf="isselectionsummarycollapse">
        <div class="overLay visible" (click)="OnCloseClick()"></div>
        <div class="selection-summary-container" [class.visible]="isselectionsummarycollapse2">
          <div class="selection-summary-block">
            <div class="selection-header">
              <div class="selection-text">{{isselectionHeader}}</div>
              <div class="selection-icon" (click)="OnCloseClick()">
                <div class="icon1"></div>
              </div>
            </div>
            <div class="summary-view" *ngIf="!showSnapshot">
              <div class="summary-view-outer">
                <div class="summary-header">Study Type</div>
                <div class="selection-summary-view-text">
                  <div class="selection-header-container">
                    <span class="selection-key">Study Type:</span>
                    <span class="selection-value">{{selected_study}}</span>
                  </div>
                </div>

                <div class="summary-header">Column</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of Columnselections" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>

                <div class="summary-header">Row</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of Rowselections" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>

                <div class="summary-header">Filters</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of AllSelections" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="summary-view" *ngIf="showSnapshot && !failedCase">
              <div class="summary-view-outer">
                <!-- Compare Across section -->
                <div class="summary-header">Compare Across</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let title of titleSection" class="selection-header-container">
                    <span class="selection-key">{{title.key}}:</span>
                    <span class="selection-value">{{title.value}}</span>
                  </div>
                </div>

                <!-- Entry Point section -->
                <div class="summary-header" *ngIf="entryPoints.length > 0">Entry Point</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let entry of entryPoints" class="selection-header-container">
                    <span class="selection-key">{{entry.key}}:</span>
                    <span class="selection-value">{{entry.value}}</span>
                  </div>
                </div>

                <!-- Selections section -->
                <div class="summary-header">Selections</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of selections" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chat History Overlay -->
    <div class="chat-history-overlay" [class.closing]="isClosing" *ngIf="isChatHistoryOpen"
      (click)="onCloseChatHistory()">
      <div class="chat-history-modal" [class.closing]="isClosing" (click)="$event.stopPropagation()">
        <div class="chat-history-header">
          <h2 class="chat-history-title">Chats</h2>
          <div class="header-controls" (click)="onBackClickChatHistory()">
            <div class="filter-back-icon"></div>
          </div>
        </div>
        <div class="chat-accordion-section">
          <div class="chat-accordion-list">
            <div class="chat-accordion-item" [class.expanded]="item.isExpanded" *ngFor="let item of chatAccordions">
              <div class="accordion-header" (click)="toggleAccordion(item)">
                <div class="question-icon-wrapper">
                  <div class="accordion-icon" [class.expanded]="item.isExpanded">
                    <div class="collapse-icon" *ngIf="item.isExpanded"></div>
                    <div class="expand-icon" *ngIf="!item.isExpanded"></div>
                  </div>
                </div>
                <div class="accordion-questions-list">
                  <p class="accordion-main-question">{{ item.mainQuestion }}</p>
                </div>
              </div>
              <div class="accordion-content" *ngIf="item.isExpanded">
                <div class="accordion-sub-questions" *ngIf="item.questions.length > 0">
                  <p class="sub-question-text" *ngFor="let question of item.questions"
                    (click)="getChatResponse(question.MessageId)">{{ question.Question }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-search-section">
          <div class="chat-search-input-wrapper">
            <input type="text" class="chat-search-input" placeholder="Search Chats" [(ngModel)]="chatSearchText"
              (input)="onChatSearch()" />
            <div class="search-icon"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Question Browser Overlay -->
    <div class="chat-history-overlay" [class.closing]="isClosing" *ngIf="isQuestionBrowserOpen"
      (click)="toggleQuestionBrowser()">
      <div class="chat-history-modal" [class.closing]="isClosing" (click)="$event.stopPropagation()">
        <div class="chat-history-header">
          <h2 class="chat-history-title">Question Browser</h2>
          <div class="header-controls" (click)="toggleQuestionBrowser()">
            <div class="filter-back-icon"></div>
          </div>
        </div>
        <!-- Empty State -->
        <div class="empty-state-section" *ngIf="matchedQuestions.length === 0">
          <div class="empty-state-icon">🔍</div>
          <h3 class="empty-state-title">No Questions Found</h3>
          <p class="empty-state-description">Try adjusting your search terms</p>
        </div>

        <!-- Questions List -->
        <div class="chat-accordion-section" *ngIf="matchedQuestions.length > 0">
          <div class="chat-accordion-list">
            <!-- Reuse existing styles but simpler list structure -->
            <div class="accordion-sub-questions" style="display: block; padding: 12px 10px;">
              <div class="question-browser-item" *ngFor="let q of matchedQuestions"
                (click)="onQuestionBrowserClick(q)">
                <div class="question-browser-text">{{ q.question }}</div>
                <div class="question-browser-meta">{{ q.chatTitle }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-search-section">
          <div class="chat-search-input-wrapper">
            <input type="text" class="chat-search-input" placeholder="Search Questions..."
              [(ngModel)]="questionBrowserSearchText" (input)="onQuestionBrowserSearch()" />
            <div class="search-icon"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Saved Questions Overlay -->
    <div class="saved-questions-overlay" [class.closing]="isClosing" *ngIf="isSavedQuestionsOpen"
      (click)="onCloseSavedQuestions()">
      <div class="saved-questions-modal" [class.closing]="isClosing" (click)="$event.stopPropagation()">
        <div class="saved-questions-header">
          <h2 class="saved-questions-title">Saved Questions</h2>
          <div class="header-controls" (click)="onBackClickSavedQuestions()">
            <div class="filter-back-icon"></div>
          </div>
        </div>

        <!-- Loading State -->
        <div class="saved-questions-loading" *ngIf="isLoadingStarredMessages">
          <div class="loading-spinner"></div>
        </div>

        <!-- Empty State -->
        <div class="empty-state-section" *ngIf="!isLoadingStarredMessages && filteredStarredMessages.length === 0">
          <div class="empty-state-icon">⭐</div>
          <h3 class="empty-state-title">No Questions Saved</h3>
          <p class="empty-state-description">Saved questions in chats will appear here</p>
        </div>

        <!-- Starred Messages List -->
        <div class="saved-questions-list-section"
          *ngIf="!isLoadingStarredMessages && filteredStarredMessages.length > 0">
          <div class="saved-questions-list">
            <div class="saved-question-item" *ngFor="let message of filteredStarredMessages"
              (click)="onStarredQuestionClick(message)">
              <div class="saved-question-icon">
                <div class="star-filled-icon"></div>
              </div>
              <div class="saved-question-content">
                <p class="saved-question-text">{{ message.Question }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="saved-questions-search-section">
          <div class="saved-questions-search-input-wrapper">
            <input type="text" class="saved-questions-search-input" placeholder="Search Saved Questions"
              [(ngModel)]="starredSearchText" (input)="onStarredSearch()" />
            <div class="search-icon"></div>
          </div>
        </div>
      </div>
    </div>


    <!-- Loading Overlay -->
    <div class="loader-container" *ngIf="arktabaccess">
      <div class="loader-wrapper">
        <div class="loader"></div>
      </div>
    </div>

    <!-- Toast Notification -->
    <div class="toast-notification" *ngIf="showToastNotification" [class.success]="toastType === 'success'" [class.error]="toastType === 'error'" [class.info]="toastType === 'info'">
      <div class="toast-icon">
        <span *ngIf="toastType === 'success'">✓</span>
        <span *ngIf="toastType === 'error'">✕</span>
        <span *ngIf="toastType === 'info'">ℹ</span>
      </div>
      <div class="toast-message">{{ toastMessage }}</div>
      <div class="toast-close" (click)="showToastNotification = false">×</div>
    </div>